var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidObject2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1040_152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -62,
    y: 71,
    width: 1612,
    height: 758
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9701 828.453L-61.0337 828.453L-61.0337 631.57L29.9701 631.57C72.2562 631.57 106.536 597.29 106.536 555.004L106.536 311.744C106.536 179.086 214.076 71.5464 346.733 71.5464C479.391 71.5464 586.931 179.086 586.931 311.744L586.931 595.256C586.931 615.312 603.189 631.57 623.245 631.57C643.301 631.57 659.559 615.311 659.559 595.256L659.559 306.494C659.559 176.736 764.748 71.5464 894.506 71.5463C1024.26 71.5463 1129.45 176.736 1129.45 306.494L1129.45 593.506C1129.45 614.528 1146.5 631.57 1167.52 631.57C1188.54 631.57 1205.58 614.528 1205.58 593.506L1205.58 344.995C1205.58 193.974 1328.01 71.5463 1479.03 71.5463L1549.03 71.5463L1549.03 268.43L1479.03 268.43C1436.74 268.43 1402.46 302.709 1402.46 344.995L1402.46 593.506C1402.46 723.264 1297.28 828.453 1167.52 828.453C1037.76 828.453 932.57 723.264 932.57 593.506L932.57 306.494C932.57 285.471 915.528 268.43 894.506 268.43C873.484 268.43 856.442 285.472 856.442 306.494L856.442 595.256C856.442 724.047 752.036 828.453 623.245 828.453C494.454 828.453 390.048 724.047 390.048 595.256L390.048 311.744C390.048 287.822 370.655 268.43 346.733 268.43C322.812 268.43 303.419 287.822 303.419 311.744L303.419 555.004C303.419 706.026 180.992 828.453 29.9701 828.453Z",
    fill: "url(#paint0_linear_1040_152)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1040_152)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1040_152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9701 828.453L-61.0337 828.453L-61.0337 631.57L29.9701 631.57C72.2562 631.57 106.536 597.29 106.536 555.004L106.536 311.744C106.536 179.086 214.076 71.5464 346.733 71.5464C479.391 71.5464 586.931 179.086 586.931 311.744L586.931 595.256C586.931 615.312 603.189 631.57 623.245 631.57C643.301 631.57 659.559 615.311 659.559 595.256L659.559 306.494C659.559 176.736 764.748 71.5464 894.506 71.5463C1024.26 71.5463 1129.45 176.736 1129.45 306.494L1129.45 593.506C1129.45 614.528 1146.5 631.57 1167.52 631.57C1188.54 631.57 1205.58 614.528 1205.58 593.506L1205.58 344.995C1205.58 193.974 1328.01 71.5463 1479.03 71.5463L1549.03 71.5463L1549.03 268.43L1479.03 268.43C1436.74 268.43 1402.46 302.709 1402.46 344.995L1402.46 593.506C1402.46 723.264 1297.28 828.453 1167.52 828.453C1037.76 828.453 932.57 723.264 932.57 593.506L932.57 306.494C932.57 285.471 915.528 268.43 894.506 268.43C873.484 268.43 856.442 285.472 856.442 306.494L856.442 595.256C856.442 724.047 752.036 828.453 623.245 828.453C494.454 828.453 390.048 724.047 390.048 595.256L390.048 311.744C390.048 287.822 370.655 268.43 346.733 268.43C322.812 268.43 303.419 287.822 303.419 311.744L303.419 555.004C303.419 706.026 180.992 828.453 29.9701 828.453Z",
    fill: "url(#paint1_radial_1040_152)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9701 828.453L-61.0337 828.453L-61.0337 631.57L29.9701 631.57C72.2562 631.57 106.536 597.29 106.536 555.004L106.536 311.744C106.536 179.086 214.076 71.5464 346.733 71.5464C479.391 71.5464 586.931 179.086 586.931 311.744L586.931 595.256C586.931 615.312 603.189 631.57 623.245 631.57C643.301 631.57 659.559 615.311 659.559 595.256L659.559 306.494C659.559 176.736 764.748 71.5464 894.506 71.5463C1024.26 71.5463 1129.45 176.736 1129.45 306.494L1129.45 593.506C1129.45 614.528 1146.5 631.57 1167.52 631.57C1188.54 631.57 1205.58 614.528 1205.58 593.506L1205.58 344.995C1205.58 193.974 1328.01 71.5463 1479.03 71.5463L1549.03 71.5463L1549.03 268.43L1479.03 268.43C1436.74 268.43 1402.46 302.709 1402.46 344.995L1402.46 593.506C1402.46 723.264 1297.28 828.453 1167.52 828.453C1037.76 828.453 932.57 723.264 932.57 593.506L932.57 306.494C932.57 285.471 915.528 268.43 894.506 268.43C873.484 268.43 856.442 285.472 856.442 306.494L856.442 595.256C856.442 724.047 752.036 828.453 623.245 828.453C494.454 828.453 390.048 724.047 390.048 595.256L390.048 311.744C390.048 287.822 370.655 268.43 346.733 268.43C322.812 268.43 303.419 287.822 303.419 311.744L303.419 555.004C303.419 706.026 180.992 828.453 29.9701 828.453Z",
    fill: "#94FF92",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1040_152",
    x: -97.2067,
    y: 71.5464,
    width: 1698.18,
    height: 820.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -36.173,
    dy: 63.3028
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.8677
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_1040_152"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 51.9376,
    dy: 30.297
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_1040_152",
    result: "effect2_innerShadow_1040_152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1040_152",
    x1: -217.903,
    y1: 237.12,
    x2: 1595.52,
    y2: 239.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132716,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1040_152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(573.458 -13.1263 1084.2 677.703 -192.441 571.954)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidObject2);
export default __webpack_public_path__ + "static/media/SolidObject-2.ca9f7e253082d8d287cbc247f3c4b5c8.svg";
export { ForwardRef as ReactComponent };